















































































import { Component, Vue, Prop } from "vue-property-decorator";
import TableComponent from "@/components/common/table/TableComponent.vue";
import TheadComponent from "@/components/common/table/TheadComponent.vue";
import TbodyComponent from "@/components/common/table/TbodyComponent.vue";
import TItemComponent from "@/components/common/table/TItemComponent.vue";
import ButtonComponent from "@/components/common/parts/ButtonComponent.vue";
import EllipsisComponent from "@/components/common/parts/EllipsisComponent.vue";
import { getRoutePath } from "@/router/routes";
import { fillZero } from "@/typescript/lib/common/fill_zero";
import { getEquipmentIcon } from "@/typescript/lib/common/get_equipment_icon";

@Component({
  components: {
    TableComponent,
    TheadComponent,
    TbodyComponent,
    TItemComponent,
    ButtonComponent,
    EllipsisComponent
  }
})
export default class extends Vue {
  @Prop()
  sensors: any;

  getRoutePath(pageName: string, params: {}): string {
    return getRoutePath(pageName, params);
  }

  getYYYYMMDD(date: string | null): string {
    if (date == null) {
      return "";
    } else {
      return date.slice(0, 10);
    }
  }

  zeroPadding(num: number, length: number) {
    return fillZero(num, length);
  }

  getCategoryImage(iconNum: number, status: "on" | "off"): string {
    return getEquipmentIcon(iconNum, status);
  }
}
